export const environment = {
  production: true,
  version: '20260624082832', // Replaced during build/deployment with YYYYMMDDhhmmss format
  api: {
    hostUrl: 'https://dev-api.rfp.agilesourcing.ai',
    baseUrl: 'https://dev-api.rfp.agilesourcing.ai/api',
  },
};
